(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const body = drawer.querySelector('[data-cart-drawer-body]');
  const renderUrl = drawer.dataset.cartDrawerRenderUrl;

  let lastFocused = null;

  const openDrawer = () => {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    // trigger reflow para que la transición se aplique
    void drawer.offsetHeight;
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('cart-drawer-open');

    const closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 220);

    // Solo hidratar recomendaciones en desktop (>=750px) — no molestar mobile
    if (window.matchMedia('(min-width: 750px)').matches) loadRecommendations();
  };

  const closeDrawer = () => {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open');
    stopRecsAuto();
    setTimeout(() => {
      if (!drawer.hasAttribute('data-open')) drawer.hidden = true;
    }, 300);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  };

  // Cualquier click en un elemento con [data-cart-drawer-open] abre.
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer();
      return;
    }
    const closer = e.target.closest('[data-cart-drawer-close]');
    if (closer && drawer.contains(closer)) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.hasAttribute('data-open')) closeDrawer();
  });

  // ---------- Swipe-to-close en mobile (arrastrar la barrita del header) ----------
  // Gesto natural del bottom sheet: si el user arrastra el header/grabber hacia
  // abajo, el panel sigue el dedo. Al soltar, si paso el umbral cierra; sino
  // vuelve arriba. Solo en mobile (<750px).
  (() => {
    const panel = drawer.querySelector('.cart-drawer__panel');
    const header = drawer.querySelector('.cart-drawer__header');
    if (!panel || !header) return;

    let startY = 0;
    let currentY = 0;
    let dragging = false;
    let panelH = 0;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const onDown = (e) => {
      if (!isMobile() || !drawer.hasAttribute('data-open')) return;
      // Ignorar si el touch empieza en un boton interactivo del header
      if (e.target.closest('button, a, input')) return;
      startY = e.touches ? e.touches[0].clientY : e.clientY;
      currentY = startY;
      dragging = true;
      panelH = panel.getBoundingClientRect().height || 500;
      panel.style.transition = 'none';
    };

    const onMove = (e) => {
      if (!dragging) return;
      currentY = e.touches ? e.touches[0].clientY : e.clientY;
      const delta = currentY - startY;
      if (delta <= 0) {
        panel.style.transform = 'translateY(0)';
        return;
      }
      // Previene el scroll del body mientras arrastra
      if (e.cancelable) e.preventDefault();
      panel.style.transform = 'translateY(' + delta + 'px)';
    };

    const onUp = () => {
      if (!dragging) return;
      dragging = false;
      const delta = currentY - startY;
      panel.style.transition = '';
      panel.style.transform = '';
      // Umbral: 25% de la altura del panel o 100px, lo que sea menor
      const threshold = Math.min(panelH * 0.25, 100);
      if (delta > threshold) closeDrawer();
    };

    header.addEventListener('touchstart', onDown, { passive: true });
    header.addEventListener('touchmove', onMove, { passive: false });
    header.addEventListener('touchend', onUp);
    header.addEventListener('touchcancel', onUp);
  })();

  // ---------- Refresh contenido vía Section Rendering API ----------
  const refresh = async () => {
    if (!renderUrl || !body) return;
    try {
      const r = await fetch(renderUrl, {
        headers: { 'Accept': 'text/html' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!r.ok) return;
      const html = await r.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer-fragment]');
      if (fresh) {
        body.innerHTML = fresh.innerHTML;
        // El bloque de recs vive dentro de body y fue reemplazado — reset
        // para que se rehidrate en la proxima apertura / hover del drawer.
        recsLoaded = false;
        recsIndex = 0;
        stopRecsAuto();
        if (drawer.hasAttribute('data-open') && window.matchMedia('(min-width: 750px)').matches) {
          loadRecommendations();
        }
      }
    } catch (_) {}
  };

  // ---------- Operaciones sobre líneas del carrito ----------
  const changeLine = async (lineIndex, quantity, itemEl) => {
    if (itemEl) itemEl.setAttribute('data-loading', 'true');
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line: lineIndex, quantity })
      });
    } catch (_) {}
    await refresh();
    // Notificamos al resto del theme (badges, etc.).
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
    if (window.NQLN && typeof window.NQLN.broadcastCartUpdate === 'function') {
      window.NQLN.broadcastCartUpdate();
    }
    if (window.NQLN && typeof window.NQLN.syncCartBadge === 'function') {
      window.NQLN.syncCartBadge();
    }
  };

  drawer.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-cart-drawer-remove]');
    if (removeBtn) {
      const line = parseInt(removeBtn.dataset.line, 10);
      const itemEl = removeBtn.closest('[data-cart-drawer-item]');
      changeLine(line, 0, itemEl);
      return;
    }

    const qtyBtn = e.target.closest('[data-cart-drawer-qty]');
    if (qtyBtn) {
      const line = parseInt(qtyBtn.dataset.line, 10);
      const itemEl = qtyBtn.closest('[data-cart-drawer-item]');
      const input = itemEl && itemEl.querySelector('[data-cart-drawer-qty-input]');
      if (!input) return;
      const dir = qtyBtn.dataset.cartDrawerQty === 'plus' ? 1 : -1;
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + dir);
      input.value = String(next);
      changeLine(line, next, itemEl);
    }
  });

  drawer.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-drawer-qty-input]');
    if (!input) return;
    const line = parseInt(input.dataset.line, 10);
    const quantity = Math.max(0, parseInt(input.value, 10) || 0);
    const itemEl = input.closest('[data-cart-drawer-item]');
    changeLine(line, quantity, itemEl);
  });

  // ---------- Reaccionar a cambios externos (product-card-actions) ----------
  const isCartPage = document.body.classList.contains('template-cart');

  document.addEventListener('cart:updated', async (e) => {
    const source = e && e.detail && e.detail.source;
    // Evitar loop: los cambios que originamos nosotros no re-refrescan.
    if (source === 'cart-drawer') return;
    // Refresh PRIMERO para que cuando el drawer se abra el HTML ya
    // este actualizado con el item nuevo, sus ofertas, ahorros, etc.
    await refresh();
    // Auto-abrir el drawer al agregar desde una card, EXCEPTO:
    // - si el evento viene de la propia cart page (user ya la está viendo)
    // - si source === 'auto-suppress' (para futuros callers que no quieran abrir)
    // - si estamos ya en la cart page
    if (source === 'cart-page' || source === 'auto-suppress' || isCartPage) return;
    if (!drawer.hasAttribute('data-open')) openDrawer();
  });

  // ============ Recomendaciones (solo desktop) ============
  // Consulta on-demand porque el markup vive en cart-drawer-content, que se
  // reemplaza en cada refresh() via Section Rendering API.
  const getRecsEls = () => ({
    root: drawer.querySelector('[data-cart-recs]'),
    track: drawer.querySelector('[data-cart-recs-track]'),
    viewport: drawer.querySelector('[data-cart-recs-viewport]'),
  });

  let recsLoaded = false;
  let recsIndex = 0;
  let recsAutoTimer = null;
  const RECS_LIMIT = 8;
  const RECS_INTERVAL = 2000;

  function formatMoney(cents) {
    // Shopify money helper minimo: divide por 100 y agrega formato local.
    // Si el theme expone Shopify.formatMoney, lo usamos; sino formato basico.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); } catch (_) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Full HTML-attribute encoder. Escapa &, <, >, ", ' — evita que un titulo o
  // URL con comillas rompa el atributo y permita inyectar handlers/scripts.
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Sanea URLs: solo permite paths relativos (/...) o http/https absolutos.
  // Bloquea javascript:, data:, y otros schemes que podrian ejecutar codigo.
  function safeUrl(u) {
    if (!u) return '';
    const s = String(u).trim();
    if (s.startsWith('/') || /^https?:\/\//i.test(s)) return s;
    return '';
  }

  function buildRecCard(p) {
    const url = safeUrl(p.url);
    const img = safeUrl(p.featured_image || (p.images && p.images[0]) || '');
    const price = p.price;
    const comparePrice = p.compare_at_price || 0;
    const hasDiscount = comparePrice > price;
    const pct = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
    const title = esc(p.title);
    const priceHtml = formatMoney(price);
    const compareHtml = hasDiscount ? formatMoney(comparePrice) : '';

    // Variant id del primer variant disponible para el boton +
    let variantId = '';
    if (p.variants && p.variants.length) {
      const firstAvail = p.variants.find(v => v.available) || p.variants[0];
      variantId = firstAvail && firstAvail.id ? firstAvail.id : '';
    }

    return `
      <li class="cart-drawer__rec-item">
        <a class="cart-drawer__rec" href="${esc(url)}" aria-label="${title}">
          <div class="cart-drawer__rec-media">
            ${img ? `<img class="cart-drawer__rec-img" src="${esc(img)}" loading="lazy" alt="${title}" width="52" height="52">` : ''}
            ${pct > 0 ? `<span class="cart-drawer__rec-badge">-${pct}%</span>` : ''}
          </div>
          <div class="cart-drawer__rec-info">
            <span class="cart-drawer__rec-title">${title}</span>
            <div class="cart-drawer__rec-price">
              <span class="cart-drawer__rec-price-final">${priceHtml}</span>
              ${hasDiscount ? `<span class="cart-drawer__rec-compare">${compareHtml}</span>` : ''}
            </div>
          </div>
        </a>
        ${variantId ? `<button type="button" class="cart-drawer__rec-add" data-cart-rec-add data-variant-id="${esc(variantId)}" aria-label="Agregar ${title}">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>
        </button>` : ''}
      </li>
    `;
  }

  async function addRecToCart(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.setAttribute('data-loading', '1');
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!r.ok) throw new Error('add failed');
      if (btn) {
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1200);
      }
      await refresh();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
      if (window.NQLN && typeof window.NQLN.broadcastCartUpdate === 'function') window.NQLN.broadcastCartUpdate();
      if (window.NQLN && typeof window.NQLN.syncCartBadge === 'function') window.NQLN.syncCartBadge();
    } catch (_) {}
    if (btn) btn.removeAttribute('data-loading');
  }

  async function loadRecommendations() {
    const { root, track } = getRecsEls();
    if (!root || !track || recsLoaded) return;
    let anchorId = null;
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (r.ok) {
        const cartData = await r.json();
        if (cartData.items && cartData.items.length) anchorId = cartData.items[0].product_id;
      }
    } catch (_) {}
    if (!anchorId) return;

    try {
      const recsUrl = `/recommendations/products.json?product_id=${anchorId}&limit=${RECS_LIMIT}&intent=related`;
      const r = await fetch(recsUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!r.ok) return;
      const data = await r.json();
      const products = (data && data.products) || [];
      if (!products.length) return;

      track.innerHTML = products.map(buildRecCard).join('');
      root.classList.add('is-loaded');
      recsLoaded = true;
      recsIndex = 0;
      startRecsAuto();
    } catch (_) {}
  }

  function slideRecs(dir) {
    const { track, viewport } = getRecsEls();
    if (!track || !viewport) return;
    const items = track.children;
    if (items.length === 0) return;
    const rowH = items[0].getBoundingClientRect().height;
    const gap = parseFloat(getComputedStyle(track).gap) || 6;
    const step = rowH + gap;
    const viewportH = viewport.clientHeight;
    const visible = Math.max(1, Math.floor(viewportH / step));
    const maxIndex = Math.max(0, items.length - visible);

    if (dir === 'next') {
      recsIndex = recsIndex >= maxIndex ? 0 : recsIndex + 1;
    } else if (dir === 'prev') {
      recsIndex = recsIndex <= 0 ? maxIndex : recsIndex - 1;
    }
    track.style.transform = `translateY(${-recsIndex * step}px)`;
  }

  function startRecsAuto() {
    stopRecsAuto();
    recsAutoTimer = setInterval(() => slideRecs('next'), RECS_INTERVAL);
  }
  function stopRecsAuto() {
    if (recsAutoTimer) { clearInterval(recsAutoTimer); recsAutoTimer = null; }
  }

  // Delegacion: los elementos viven en cart-drawer-content y se reemplazan
  // en cada refresh, asi que binding directo no sobrevive.
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-recs-prev]')) { slideRecs('prev'); startRecsAuto(); return; }
    if (e.target.closest('[data-cart-recs-next]')) { slideRecs('next'); startRecsAuto(); return; }
    const addBtn = e.target.closest('[data-cart-rec-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      addRecToCart(addBtn.dataset.variantId, addBtn);
    }
  });
  drawer.addEventListener('mouseenter', (e) => {
    if (e.target && e.target.closest && e.target.closest('[data-cart-recs]')) stopRecsAuto();
  }, true);
  drawer.addEventListener('mouseleave', (e) => {
    if (e.target && e.target.closest && e.target.closest('[data-cart-recs]')) {
      if (recsLoaded) startRecsAuto();
    }
  }, true);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopRecsAuto();
    else if (recsLoaded && drawer.hasAttribute('data-open')) startRecsAuto();
  });
})();
